export default function generateUniqueGroupName(groupName: string, groupNames: string[]) {
    let i = 1;
    let newName = `${groupName} (${i})`;

    while (groupNames.includes(newName)) {
        i++;
        newName = `${groupName} (${i})`;
    }

    return newName;
}
